import type { HasFieldErrorsProps } from "./types";

export const hasFieldErrors = ({
	formState,
	fieldState,
	fieldName,
}: HasFieldErrorsProps) => {
	const { touchedFields, errors, isDirty } = formState;

	const hasFieldError =
		(touchedFields[fieldName] || isDirty) && errors?.[fieldName]?.message;

	return hasFieldError && fieldState?.error?.message !== "-";
};
